import { TNetworkIdentifier } from 'src/common/models/networkIdentifier';
import { IAdvertiserPublisherRelation } from 'src/common/models/advertiserPublisherRelation';
import getReach from './getReach';
import getEngagement from './getEngagement';

export default function getEngagementRate(
  relation: IAdvertiserPublisherRelation,
  network?: TNetworkIdentifier,
) {
  const engagement = getEngagement(relation, network);
  const reach = getReach(relation, network);
  return reach > 0 ? engagement / reach : null;
}
